<template>
  <import-charge-tab lob="SI" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeSI',
  components: { importChargeTab }
}
</script>
